module.exports = __webpack_public_path__ + "0df9a37f0f3d5c69a7952879bb082778.png";